<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center mb-2 mt-2 pb-2 globalborder-btm-header px-3">
        <span class="col-auto">
          <h2 class="mb-0">
            New Line Group
            <!-- <jni-spinner *ngIf="showSmallLoader"></jni-spinner> -->
          </h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <span class="cross-border" (click)="closeModal()"
            ><i class="pi pi-times"></i></span
        ></span>
      </span>

      <div class="col-12 content-scroll-screen">
        <div class="row">
          <div class="col-4">
            <div class="gap-2 d-flex align-items-center">
              <p-radiobutton
                id="Existing"
                name="radio"
                [(ngModel)]="templateType"
                value="existing"
                (onClick)="templateTypeChange('existing')" />

              <label class="mt-1">Add Existing Finished Goods Template</label>
            </div>
          </div>

          <div class="col-4">
            <div class="gap-2 d-flex align-items-center">
              <p-radiobutton
                id="Create"
                [(ngModel)]="templateType"
                name="radio"
                value="create"
                (onClick)="templateTypeChange('create')" />

              <label class="mt-1">Create Finished Goods Template</label>
            </div>
          </div>
        </div>
        <jni-create-finished-goods-template
          *ngIf="templateType === 'create'"
          [parent]="parent"
          [saleOrderIdFromModal]="saleOrderIdFromModal"
          [lineGroup]="lineGroup"
          [site]="site || ''"
          [warehouse]="warehouse || ''"
          [saleOrderModalStatus]="true"
          [jobNameD365]="jobNameD365 || ''"
          [wMSLocationD365]="wMSLocationD365 || ''"
          [ownerD365]="owner || ''"
          [store]="store || ''"
          (refreshGridEmit)="refreshGridEmit.emit()"
          (closeModalEmit)="
            this.closeModalEmit.emit()
          "></jni-create-finished-goods-template>
        <jni-add-existing-finished-goods-template
          *ngIf="templateType === 'existing'"
          [parent]="parent"
          [saleOrderIdFromModal]="saleOrderIdFromModal"
          [lineGroup]="lineGroup"
          [site]="site || ''"
          [warehouse]="warehouse || ''"
          [saleOrderModalStatus]="true"
          [jobNameD365]="jobNameD365 || ''"
          [wMSLocationD365]="wMSLocationD365 || ''"
          [owner]="owner || ''"
          [store]="store || ''"
          (refreshGridEmit)="refreshGridEmit.emit()"
          (closeModalEmit)="this.closeModalEmit.emit()"
          [purchaseOrderHeader]="purchaseOrderHeader"
          [purchaseOrderHeaderAddress]="
            purchaseOrderHeaderAddress
          "></jni-add-existing-finished-goods-template>
      </div>
    </p-card>
  </div>
</div>
